import React, { useCallback, useMemo } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { FormattedMessage } from 'react-intl'
import Header from '../header'
import { Iconfont } from '../../../../components/icon/iconfont'
import SeurePayment from '../secure-payment'

const CountryDisplay = props => {
    useStyles(classes)
    const { countryClick, shippingDetail, country } = props;

    const concatstr = (...strs) => {
        let filted = strs.filter(s => !!s)
        return filted.join(' ')
    }

    const shippingAddress = useMemo(() =>{
        if(shippingDetail){
            let adrs = shippingDetail;
            return concatstr(adrs.streetAddress1, adrs.unit, adrs.city, adrs.state?.label, adrs.country?.value);
        }
        
        return country;
    }, [country, shippingDetail]);

    return <span className={classes.CountryDisplay} onClick={countryClick}>
        <Iconfont className={classes.Icon}>&#xe691;</Iconfont>
        <span className={classes.Content}>
            <FormattedMessage id="ships_to_country" defaultMessage="Ships To {country}" values={{ country: shippingAddress }} />
        </span>
    </span>
}

export default props => {
    useStyles(classes)
    const { onBack, onEdit, onWish, children, countryClick, isEmpty, shippingDetail, country,regionalCases } = props
    let caseItems=[]
    if(regionalCases && regionalCases.length>0){
        // caseItems = regionalCases[0].caseItems
        //     || [];
        caseItems = regionalCases
            .flatMap(region => region.caseItems || [])                   // 所有 caseItems
    }
    const selectedCount = caseItems.reduce((count, caseItem) => {
         return count + caseItem.shoppingCartProducts.filter(product => product.selected).length;
         }, 0);
    return <div className={classes.CartPage}>
        <Header onBack={onBack} extra={
            <>
                {
                    !isEmpty && <Iconfont className={classes.Icon} onClick={onEdit}>&#xe7b6;</Iconfont>
                }
                
                <Iconfont className={classes.Icon} onClick={onWish}>&#xe6a2;</Iconfont>
            </>
        }>
            <div className={classes.BagTitle}>
                <FormattedMessage id="bag" defaultMessage={'Bag'} />({selectedCount})
            </div>
            {
                country && !isEmpty && <div className={classes.CountryDisplayParent}>
                    <CountryDisplay countryClick={countryClick} shippingDetail={shippingDetail} country={country} />
                </div>
            }
        </Header>
        {children}
    </div>
}